<template lang="pug">

  transition(name="fade")
    #questions(@click="onClick" @touchstart="onTouchStart" @touchend="onTouchEnd")
      .wrap(ref="wrap")
        div.transition-group.copy(name="fade")
          initial-copy(v-if="canShowInitialCopy" key="2" :copy="getInitialCopy" :initialShow="firstInitialCopyShow")
          return-copy(v-if="canShowCopy" key="3" :copy="getReturnCopy")
          
      emotional-meter
      error-msg
      transcription(v-if="canShowTranscription")

</template> 

<script>


import { mapState, mapMutations, mapGetters } from 'vuex'
import { map, randomInRange } from '@/helpers/MathUtils'
import { findWhere } from '@/helpers/ArrayUtils'
import Touch from '@/helpers/Touch'
import ImageService from 'src/services/ImageService'
import EmotionalMeter from '@/components/EmotionalMeter' 
import ErrorMsg from '@/components/ErrorMsg' 
import CanvasData from 'src/components/textbg/data'
import Transcription from 'src/components/transcription'
import InitialCopy from 'src/components/copy/initial'
import ReturnCopy from 'src/components/copy/return'
import TweenMax from 'gsap'
import SplitText from 'src/components/_utils/SplitText'

export default {

  name: 'questions',
  
  components: {
    EmotionalMeter,
    SplitText,
    Transcription,
    InitialCopy,
    ReturnCopy,
    ErrorMsg
  },
  
  data() {
    return {  
      firstInitialCopyShow: true,
      tweenObj: {
        tap_hold: 0,
        timer:1
      },
      canvasData: CanvasData.question
    }
  },
  
  computed: {

    ...mapState('app', ['loading']),
    ...mapState('browser', ['isMobile', 'isDesktop', 'debug']),
    ...mapState('question', [
      'state', 
      'prev_state', 
      'STATES', 
      'initialShow', 
      'result', 
      'targetIndex', 
      'GOALS', 
      'goal',
      'goals_completed',
      'collection',
      'tap_hold_cta',  
      'tap_hold_cta_valid',  
      'transcription'
    ]),

    canErrorMsg(){
      return (this.state === this.STATES.ERROR);
    }, 

    getInitialCopy(){
      return 'Lets start by making him ' + this.introCopy;
    },

    getReturnCopy(){
      return 'Now try making him ' + this.introCopy;
    },

    canShowCTA() {
      return (this.state === this.STATES.IDLE || this.state === this.STATES.TAP_HOLD_RELEASE /*|| this.state === this.STATES.TAP_HOLD_PROGRESS*/);
    },

    canShowInitialCopy() {
      return (this.canShowCTA&& this.initialShow);
    },

    canShowCopy() {
      return (this.canShowCTA && !this.tap_hold_cta && !this.initialShow);
    },

    introCopy() { 
      return (this.goal) ? this.goal.copy.intro : ''; 
    },

    canShowTranscription() {
      return (this.transcription && (this.state === this.STATES.PROCESSING || this.state === this.STATES.COMPLETE) );
    }
  },
  
  mounted() { 
    this.setState(this.STATES.INTRO); 
    let delay = this.initialShow ? 3 : 0;
    TweenMax.delayedCall(delay, ()=>{
      this.setState(this.STATES.IDLE); 
    });
  },
  
  beforeDestroy() {},
  
  methods: {

    ...mapMutations('question', [
      'setState', 
      'setResult', 
      'setTapHoldRatio',
      'setTapHoldValid',
      'setTapHoldCTA',
      'setTimerRatio',
      'setIntialShow'
    ]),
 
    onClick() { 
      if(!this.isMobile){
        this.updateObey(); // toggle listening
      }
    },

    onTouchStart() { 
      if(
        this.state === this.STATES.IDLE || 
        this.state === this.STATES.TAP_HOLD_RELEASE 
      ){
        this.setState(this.STATES.TAP_HOLD_PROGRESS); 
      } 
      this.firstInitialCopyShow = false;
      this.invalidateTapHold();
    },

    onTouchEnd() {

      TweenMax.killTweensOf(this.tweenObj);

      if(this.state === this.STATES.TAP_HOLD_RECORD){
        this.setState(this.STATES.PROCESSING);
      } else if(this.state === this.STATES.TAP_HOLD_PROGRESS){
        this.setState(this.STATES.TAP_HOLD_RELEASE);
      } 
    },

    onTouchStartComplete() {
      this.setState(this.STATES.TAP_HOLD_RECORD);
    }, 

    onTouchEndComplete() {
      this.setState(this.STATES.IDLE);
    },

    onUpdate(){ 
      this.setTapHoldRatio(this.tweenObj.tap_hold); 
    },

    onTimerUpdate(){
      this.setTimerRatio(this.tweenObj.timer);
    },

    onTimerComplete(){
      this.setState(this.STATES.PROCESSING);
    },

    updateObey: function() { },
 
    reset() {
      this.setResult({ 
        score: 0,
        magnitude: 0
      });
    },

    invalidateTapHold(){
      TweenMax.killTweensOf(this.tapHoldDelay);
      this.setTapHoldCTA(false) 
      this.setTapHoldValid(false) 
    },


    /* state handlers */

    updateState(val) {
      switch(val) {
        case this.STATES.IDLE:
          this.idle();
          break;
        case this.STATES.TAP_HOLD_PROGRESS:
          this.tapholdProgress();
          break;
        case this.STATES.TAP_HOLD_RECORD:
          this.tapholdRecord();
          break; 
        case this.STATES.TAP_HOLD_RELEASE:
          this.tapholdRelease();
          break; 
        case this.STATES.PROCESSING:
          this.processing();
          break; 
        case this.STATES.COMPLETE:
          this.complete();
          break; 
        case this.STATES.ERROR:
          this.error();
          break; 
      } 
    },

    idle() {
      if(this.tap_hold_cta_valid){
        TweenMax.delayedCall( 10, this.tapHoldDelay); 
        this.setTapHoldValid(false)
      }
    },

    error() {
      console.log('ERROR')
    },

    tapHoldDelay() {
      this.setTapHoldCTA(true);
    },

    tapholdProgress() {

      this.random = {
        x: {
          mult: Math.random(),
          dist: Math.random() * 0.1
        },
        y: {
          mult: Math.random(),
          dist: Math.random() * 0.1
        }
      }

      TweenMax.to(this.tweenObj, 0.7, {
        'tap_hold': 1,
        'ease': 'Linear.easeNone',
        'onUpdate': this.onUpdate,
        'onComplete': this.onTouchStartComplete
      }); 
    },
    
    tapholdRecord() {
 
      TweenMax.to(this.tweenObj, 5, {
        'timer': 0, 
        'ease': 'Quad.easeInOut', 
        'onUpdate': this.onTimerUpdate,
        'onComplete':  this.onTimerComplete
      }); 
    },

    tapholdRelease() { 
  
      TweenMax.to(this.tweenObj, 1, {
        'tap_hold': 0,
        'ease': 'Power3.easeOut',
        'onUpdate': this.onUpdate, 
        'onComplete':  this.onTouchEndComplete
      }); 
    },
    
    processing() { },
    
    complete() {

      this.setIntialShow(); 
      
      TweenMax.set(this.tweenObj,   {
        'timer': 1,  
        'onUpdate': this.onTimerUpdate 
      }); 

      TweenMax.to(this.tweenObj, 1, {
        'tap_hold': 0,
        'ease': 'Power3.easeOut',
        'onUpdate': this.onUpdate 
      });

      let page = this.goals_completed ? 'endscreen' : 'result';
      TweenMax.delayedCall(7, () => { 
        this.$router.replace({ name: page}); 
      });
    } 

  },
 
 
  watch: {
    
    'state'(val){
      this.updateState(val);
    },

    'result.percentage'(val){
    }
  }

}

</script>

<style lang="sass">
@import "src/styles/common.sass"

#questions
  +full()
  +flex-center()

  .wrap
    height: 100%; 
    position: absolute;
    display: flex; 
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 70%;
    bottom: 4rem;
    position: absolute;

    .copy
      width: 100%;
      bottom: 0;
      position: absolute; 

  .copy-bg
    position: absolute;
    background: black;
    bottom: 0;
    left: 50%;
    margin-left: -150px;
 
  .bg
    top: 0;
    position: absolute;


  p
    width: 100%;
    color: white;
    margin-bottom: 4rem;
    font-size: 1.8rem;
    line-height: 1.8; 
    text-align: center;
    bottom: 0;
    position: absolute;
    transform: translate3d(0, 0, 0)
 
  .question-copy
    font-size: 1.8rem;
    padding: 1rem;
    background: #f8f4e2;
    color: #419ccd;
    margin-bottom: 0.5rem;
    padding: 0.5rem;


</style>
